import React from 'react';
import useWindowSize from '../../hooks/useWindowSize';
// import { connect } from 'react-redux';
// import PropTypes from 'prop-types';

import HomeCards from '../partials/HomeCards';
import EventCards from '../partials/EventCards';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/home.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const HomePage = ({ page }) => {
    const hasChildren = page && page.children && page.children.length > 0;
    const screenSmall = useWindowSize().width < 1200;

    if (hasChildren) {
        return (
            <div className={styles.container}>
                <div className={styles.inner}>
                    <HomeCards mainEvent={page.children[0]} />
                </div>
                {screenSmall ? null : (
                    <div className={styles.right}>
                        <EventCards
                            items={page.children.filter((p, index) => index > 0)}
                            className={styles.small}
                            format="small"
                        />
                    </div>
                )}
            </div>
        );
    }
    return null;
};

HomePage.propTypes = propTypes;

// const WithStateContainer = connect(({ site: { menus: { main } } }) => ({
//     menu: main,
// }))(HomePage);

export default HomePage;
